import React, { useEffect, useState, useRef } from "react";
import { Dimensions, Image, Text, TouchableOpacity, View, Linking, } from "react-native";
import Header from "../../common/Header";
import * as RootNavigation from "../../utilities/RootNavigation"
import { FONTS } from "../../constant";
import CImage from "../../common/CImage";
import CustomButton from "../../common/CustomButton";
import CustomTextInput from "../../common/CustomTextInput";
import CustomInput from "../../common/CustomInput";
import applicationStyles from "../../styles/applicationStyles";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles'
import LoginTabIcons from "./LoginTabIcons";
import LoginRightWidget from "./LoginRightWidget";
import LoginMoibleContent from "./LoginMobileContent";
import LoginFooter from "./LoginFooter";
import {sendOtp,validateOtp} from "../../api/apiManager";
import CountdownTimer from "../../common/CTimer.web";
import useStyles from "./ForgotUserScreen_Styles";
import CCaptcha from "../../common/CCaptcha";
import CView from '../../styles/CommonStyle';
import { Encryption as encrypt,decryptCaptcha } from "../../utilities/Encryption";
export default function ForgotUserScreen(props) {
  const otpPattern = /^\d{6}$/
  const styles = useStyles();
  const time = new Date();
  time.setSeconds(time.getSeconds() + 600);
  const [vehicleNo, setVehicleNo] = useState("");
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpResponse, setOtpResponse] = useState("");
  const [screenName, setScreenName] = useState("1");
  const [isLoading, setIsLoading] = useState("");


  
  const onClickGetOtp = () => {
   
 
    let reqObj = {
        type: "forgotUserId",
        id: vehicleNo,
        mobileNo: mobile,
      };
    onSendOtp(reqObj)
  };

  const resetData = ()=>{
    setVehicleNo("");
    setMobile("");
  }
  const onSendOtp =(reqObj)=>{
    sendOtp(reqObj).then(res=>{
      setIsLoading(false)
       
      if (res?.data?.statusCode == 1003) {
        setScreenName("2")
        setOtpResponse(res?.data)
      }else if(res?.data?.statusCode == -1004){
        resetData()
        const routeObj = {
          title:"Forgot USer Id",
          type : "Error",
          msg: res?.data?.message,
          btnText :"Ok",
          navigation : "ForgotUserScreen",
      }
      RootNavigation.navigate("ResponseScreen",{ data : routeObj  })
      }

    }).catch(err=>{
      setIsLoading(false)
    })
  }
  const onValidateOtp = () => {
    setOtp("")
    let reqObj = {
      type: "forgotUserId",
      otp: otp,
      requestId: otpResponse?.response?.otp,
    };
    validateOtp(reqObj).then(res=>{
      setIsLoading(false)
      if (res?.data?.statusCode == 1008) {
        const routeObj = {
          title:"Forgot USer Id",
          type : "success",
          msg: res?.data?.message,
          btnText :"Ok",
          navigation : "Login",
      }
      RootNavigation.navigate("ResponseScreen",{ data : routeObj  })
      }else if(res?.data?.statusCode < 0){
        resetData()
        setScreenName("1")
        const routeObj = {
          title:"Forgot USer Id",
          type : "Error",
          msg: res?.data?.message,
          btnText :"Ok",
          navigation : "ForgotUserScreen",
      }
      RootNavigation.navigate("ResponseScreen",{ data : routeObj  })
      }

    }).catch(err=>{
      setIsLoading(false)
    })
  };



  const counterRef = useRef(null);



  const renderForgotUserScreen = () =>{
    return <View style={styles.containerBox}>
    <View
      style={styles.rectangle41}
    >
      <TouchableOpacity onPress={() => RootNavigation.navigate("SelectForgotScreen")}>
        <CImage.BackIconWhite></CImage.BackIconWhite>
      </TouchableOpacity>
      <Text style={[applicationStyles.loginTextStyle]}>
        {"Forgot User Id"}
      </Text>
    </View>
    {
      screenName == "1" ? (
        <View
          style={{
            alignItems: "flex-start",
            width: "80%",
            alignSelf: "center",
          }}
        >
          <Text style={styles.labelStyle}>{"RC/Vehicle/Chassis Number"}</Text>
          <CustomTextInput value={vehicleNo} onChangeText={setVehicleNo} maxLength={20} />
          <Text
            style={[
              styles.labelStyle,
              { paddingTop: "5%", paddingBottom: 5 },
            ]}
          >
            {"Mobile Number"}
          </Text>
          <CustomTextInput
            value={mobile}
            onChangeText={setMobile}
            maxLength={10}
            type="number"
          />
          <View
            style={{
              width: 108,
              height: 37,
              alignSelf: "center",
              marginTop: 20,
            }}
          >
            <CustomButton
            onPress={!vehicleNo || !mobile ? () => {} : onClickGetOtp}
              // onPress={!vehicleNo || !mobile ? " " : onClickGetOtp}
              text={"Get OTP"}
              disable={!vehicleNo || !mobile}
            />
          </View>
        </View>
      ) : screenName == "2" ? (
        <View style={{ width: "80%", alignSelf: "center" }}>
          <Text style={applicationStyles.enterOtpDescStyle}>
          {otpResponse?.message}
          </Text>
          <Text style={applicationStyles.enterOtpTxtStyle}>
            {"Enter OTP"}
          </Text>
          <CustomInput
            value={otp}
            onValueChanged={(e) => setOtp(e)}
            style={[styles.textInputStyle, { width: 280 }]}
            maxLength={6}
            pattern={/^\d{6}$/}
            errorMessage={"Enter Valid OTP"}
            type="number"
            keyboardType="numeric"
          />
          <View style={styles.resendViewStyle}>
          <CountdownTimer
            requestOtp={screenName == "2"}
            onClickGetOtp={onClickGetOtp}
            counterRef={counterRef}
          
       
            />
        
          </View>
          <View
            style={{
              width: 108,
              height: 37,
              alignSelf: "center",
              marginTop: 20,
            }}
          >
            <CustomButton
              text={"Next"}
              onPress={!otpPattern.test(otp) ? ()=>{} : onValidateOtp}
              disable={!otpPattern.test(otp) ? true : false}
            />
          </View>
        </View>
      ) : (
        ""
      )
    }
  </View>
  }

  return (
    <View style={styles.mainContainerStyle}>
      <View style={{ flex: 1 }}>
        <Header text={"Login"} />

        <View style={styles.bodyContainerStyle}>
          <View style={styles.bodyLeftViewStyle}>
            
            {renderForgotUserScreen()}
            <LoginTabIcons />
          </View>

          <LoginRightWidget />
        </View>
        <View style={styles.mobileComponentStyle}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            <View style={{ flexDirection: "row" }}>
              <CImage.IDFCLogo></CImage.IDFCLogo>
            </View>
            <View>
              <CImage.FFLogoSmall></CImage.FFLogoSmall>
            </View>
          </View>
          <View
            style={{
              alignSelf: "center",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
           {renderForgotUserScreen()}
          </View>

          <LoginMoibleContent />
        </View>

        <LoginFooter />
      </View>


    </View>
  );
}



